





























import { Vue, Component } from "vue-property-decorator";
import { ApkDetectionPermissionTagDetailItem } from "./apk.interface";
@Component
export default class ApkDetectionPermissionUsedDialog extends Vue {
  dialog = false;
  info: ApkDetectionPermissionTagDetailItem[] = [];

  open(payload: ApkDetectionPermissionTagDetailItem[]) {
    this.dialog = true;
    this.info = payload;
  }
}
